import { render, staticRenderFns } from "./IntegrationDisconnectModal.vue?vue&type=template&id=975b2032&scoped=true&lang=pug"
import script from "./IntegrationDisconnectModal.vue?vue&type=script&lang=js"
export * from "./IntegrationDisconnectModal.vue?vue&type=script&lang=js"
import style0 from "./IntegrationDisconnectModal.vue?vue&type=style&index=0&id=975b2032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975b2032",
  null
  
)

export default component.exports